import toast, { Toaster } from 'react-hot-toast';
import '../RoomCode/styles.scss';
import squareImg from '../../assets/images/squares.svg';

type RoomCodeProps = {
  code: string;
}

export function RoomCode(props: RoomCodeProps) {

  function copyRoomCodeToClipboard() {
    navigator.clipboard.writeText(props.code);
    return toast.success('Code copied with success');
  }

  return (
    <>
      <Toaster toastOptions={{ className: "dark-toast" }} />
      <button className="room-code" onClick={copyRoomCodeToClipboard}>
        <div>
          <img src={squareImg} alt="Copy room code" />
        </div>
        <span>Sala #{props.code}</span>
      </button>
    </>
  );
}